import { CompoundPath, Group, Path, Shape } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER } from "../../constants";

export default class Frame {
  circle = this.createCircleFrame();
  shadow = new Shape.Ellipse({
    center: [CANVAS_CENTER, 90],
    size: [45, 4],
    fillColor: BORDER_COLOR,
    applyMatrix: false,
  });

  private createCircleFrame() {
    const outerCircle = new Shape.Circle({
      center: [CANVAS_CENTER, CANVAS_CENTER],
      radius: 35,
      strokeColor: BORDER_COLOR,
      strokeWidth: 2,
    });

    const outerCircleClippingPath = new CompoundPath({
      children: [
        new Path.Rectangle({
          point: [65, 10],
          size: [CANVAS_CENTER, 80],
        }),
        new Path.Rectangle({
          point: [10, 10],
          size: [22, 80],
        }),
        new Path.Rectangle({
          point: [25, CANVAS_CENTER],
          size: [CANVAS_CENTER, CANVAS_CENTER],
        }),
      ],
      clipMask: true,
    });

    const frame = new Group([outerCircle, outerCircleClippingPath]);

    return frame;
  }

  async animateIn() {
    const initialCirclePosY = this.circle.position.y;
    const initialShadowPosY = this.shadow.position.y;
    const circleTween = this.circle.tween(
      {
        "position.y": initialCirclePosY - 15,
        opacity: 0,
      },
      { "position.y": initialCirclePosY + 5, opacity: 1 },
      { duration: 300, easing: "easeOutQuad" },
    );

    const shadowTween = this.shadow.tween(
      { opacity: 0, "position.y": initialShadowPosY + 7 },
      { opacity: 1, "position.y": initialShadowPosY - 1 },
      { duration: 300, easing: "easeOutQuad" },
    );

    await Promise.all([circleTween, shadowTween]);

    const bounceCircle = this.circle.tweenTo(
      { "position.y": initialCirclePosY },
      { duration: 150, easing: "easeInOutQuad" },
    );
    const bounceShadow = this.shadow.tweenTo(
      {
        opacity: 0.7,
        "position.y": initialShadowPosY,
      },
      {
        duration: 150,
        easing: "easeInOutQuad",
      },
    );

    await Promise.all([bounceCircle, bounceShadow]);
  }
}
